import { getAnalytics } from "@tm/insurance/analytics";
import { CheckButton } from "@tm/static";
import { TextNodeType } from "@tm/ui-widgets/components";
import { ChangeEvent, useId } from "react";
import { useNetPriceContext } from "../contexts/NetPriceContext";
import FilterCriteriaLabel from "../FilterPlans/FilterCriteriaLabel";
import {
  ShowNetPriceCheckboxWrap,
  ShowNetPriceContainer,
  ShowNetPriceRow,
} from "./ShowNetPriceCard.style";

type ShowNetPriceCardProps = {
  text?: TextNodeType;
  infoIcon?: string;
  popover?: {
    description?: {
      text?: { value?: string };
    };
  };
};

const getLabelText = (text?: TextNodeType): string => {
  const value = text?.text;
  if (typeof value === "string") return value;
  if (value && typeof value === "object" && "value" in value) {
    return String((value as { value?: string }).value ?? "");
  }
  return "Show net price";
};

const ShowNetPriceCard = ({
  text,
  infoIcon,
  popover,
}: ShowNetPriceCardProps) => {
  const { showNetPrice, setShowNetPrice } = useNetPriceContext();
  const analytics = getAnalytics();
  const label = getLabelText(text);
  const checkboxId = useId();

  const handleToggle = (event: ChangeEvent<HTMLInputElement>) => {
    const nextChecked = event.target.checked;
    analytics?.trackListingEvents({
      actionType: nextChecked
        ? "net_price_checked_clicked"
        : "net_price_unchecked_clicked",
    });
    setShowNetPrice(nextChecked);
  };

  return (
    <ShowNetPriceContainer>
      <ShowNetPriceRow>
        <ShowNetPriceCheckboxWrap>
          <CheckButton
            inputId={checkboxId}
            isChecked={showNetPrice}
            handleChange={handleToggle}
          >
            <FilterCriteriaLabel
              label={label}
              infoIcon={infoIcon}
              popover={popover}
            />
          </CheckButton>
        </ShowNetPriceCheckboxWrap>
      </ShowNetPriceRow>
    </ShowNetPriceContainer>
  );
};

export default ShowNetPriceCard;
